// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.activate-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.activate-message {
  display: flex;
  font-size: 20px;
  font-weight: bold;
}
  `, "",{"version":3,"sources":["webpack://./src/app/components/login-page/activate-user.ts"],"names":[],"mappings":";;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;AACnB","sourcesContent":["\n\n.activate-content {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n}\n.activate-message {\n  display: flex;\n  font-size: 20px;\n  font-weight: bold;\n}\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
